import { fetchData } from "./api.service";
import { appInsights } from "../../core/services/insight.service";

export const fetchEmpDetails = async (
    email: string
  ): Promise<any> => {
    try {
      const response = await fetchData(
        `Employees/search-employee/${email}`
      );
      return response;
    } catch (error: any) {
      appInsights.trackEvent({ name: "FetchEmpDetailsFailed", properties: { error: error } });
      return error;
    }
  };